var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('material-card',[_c('v-card-text',[_vm._v("Acá poner lo de los assets")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }